import React, { Fragment, useContext, useState } from "react";
import clsx from "clsx";
import {
  ImageList,
  ImageListItem,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Button,
  IconButton,
} from "@material-ui/core";
import { Edit, Cancel, AddBox } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import CampaignContext from "../../../../context/campaign/CampaignContext";

// Components
import ReviewForm from "./ReviewForm";
import DeleteReview from "./confirmation/DeleteReview";

const stars =
  "https://res.cloudinary.com/dbxd5sz3e/checkout_images/misc/stars.png";

const useStyles = makeStyles((theme) => ({
  ImageList: {
    flexWrap: "nowrap",
    minWidth: "100%",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    // transform: "translateZ(0)",
  },
  card: {
    height: "95%",
    margin: "5px 5px 0 5px",
    fontSize: "12px",
    textAlign: "justifyContent",
    color: theme.palette.text.secondary,
  },
  cardTitle: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  cardAction: {
    "&:focus": {
      outline: "none",
    },
    textTransform: "none",
    padding: "6px",
  },
  cardContent: {
    paddingTop: 0,
    height: "72%",
  },
  cardReview: {
    height: "79%",
    lineHeight: 1.6,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 7,
  },
  cardName: {
    textAlign: "right",
    fontWeight: "bold",
  },
  button: {
    "&:focus": {
      outline: "none",
    },
    textTransform: "none",
    padding: "2px 10px",
    color: theme.palette.text.secondary,
  },
  button1: {
    height: "100%",
    width: "100%",
  },
}));

const TabReviewsList = () => {
  const classes = useStyles();

  const {
    default_reviews,
    checkout_data,
    checkout_error,
    setCheckoutData,
    setCheckoutError,
  } = useContext(CampaignContext);

  const [openForm, setOpenForm] = useState(false);
  const [comment, setComment] = useState({
    action: null,
    index: null,
    data: null,
  });

  const [openDelete, setOpenDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState();

  const newReview = () => {
    setOpenForm(true);

    let comment_index = checkout_data.reviews.length;

    setComment({
      action: "Create",
      index: comment_index,
      data: default_reviews,
    });
  };

  const editReview = (comment_index) => {
    setOpenForm(true);
    setComment({
      action: "Edit",
      index: comment_index,
      data: checkout_data.reviews[comment_index],
    });
  };

  const onRemove = (comment_index) => {
    setDeleteIndex(comment_index);
    setOpenDelete(true);
  };

  const saveReview = () => {
    const { index, data } = comment;

    for (let x in data) data[x] = data[x].trim();

    checkout_data.reviews[index] = data;
    setCheckoutData(checkout_data);

    if (checkout_error.reviews) {
      checkout_error.reviews = "";
      setCheckoutError(checkout_error);
    }
  };

  const removeReview = () => {
    checkout_data.reviews.splice(deleteIndex, 1);

    setCheckoutData({ ...checkout_data, reviews: checkout_data.reviews });
  };

  return (
    <ImageList className={classes.ImageList} cols={3.5} rowHeight={290}>
      {openForm && (
        <ReviewForm
          openFormState={[openForm, setOpenForm]}
          commentState={[comment, setComment]}
          saveReview={saveReview}
        />
      )}
      {openDelete && (
        <DeleteReview
          openDeleteState={[openDelete, setOpenDelete]}
          setDeleteIndex={setDeleteIndex}
          removeReview={removeReview}
          checkout_data={checkout_data}
        />
      )}
      {checkout_data.reviews.map((each, index) => (
        <ImageListItem key={index}>
          <Card raised className={classes.card}>
            <CardHeader
              avatar={<Avatar src={each.avatar} />}
              title={<img width="78px" height="13px" src={stars} alt="" />}
              subheader={
                <span className={classes.cardTitle}> Verified Purchase </span>
              }
              action={
                <Fragment>
                  <IconButton
                    className={classes.cardAction}
                    onClick={() => editReview(index)}
                  >
                    <Edit />
                  </IconButton>
                  <IconButton
                    className={classes.cardAction}
                    onClick={() => onRemove(index)}
                  >
                    <Cancel />
                  </IconButton>
                </Fragment>
              }
            />
            <CardContent className={classes.cardContent}>
              <p className={classes.cardReview}> {each.comment} </p>
              <div className={classes.cardName}>
                {each.name} <br /> {each.location}
              </div>
            </CardContent>
          </Card>
        </ImageListItem>
      ))}
      <ImageListItem>
        <Card raised className={classes.card}>
          <Button
            className={clsx(classes.button, classes.button1)}
            onClick={newReview}
          >
            <AddBox
              fontSize="large"
              color={checkout_error.reviews ? "error" : "inherit"}
            />
          </Button>
        </Card>
      </ImageListItem>
    </ImageList>
  );
};

export default TabReviewsList;
